import React from 'react';

function WorkInfo(props){
    return (
        <div className={"work-info trouble-border"}>
            <span className="title">Son İşlem</span>
            <span className="user">{props.user}</span>
            <span className="right-arrow"/>
            <span className="work">{props.work}</span><br/>
            <span className="date">{props.date}</span>
        </div>
    )
}


export default WorkInfo;